var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavyFederalCreditUnionLandingImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-6571 5170 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-mobile-phone);\n      }\n\n      .cls-2 {\n        fill: #ea7923;\n      }\n\n      .cls-3 {\n        fill: #2c4577;\n      }\n\n      .cls-4 {\n        fill: #dde4e8;\n      }\n\n      .cls-5 {\n        opacity: 0.27;\n      }\n\n      .cls-6 {\n        fill: #b4c8d2;\n      }\n\n      .cls-7 {\n        fill: #7ab4e2;\n      }\n\n      .cls-8 {\n        fill: #3b93d0;\n      }\n\n      .cls-9 {\n        fill: #f48c58;\n      }\n\n      .cls-10 {\n        fill: #fff;\n      }\n\n      .cls-11 {\n        fill: #0f3d70;\n      }\n\n      .cls-12 {\n        fill: #dcebf8;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-mobile-phone"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6571,
    y: 5170,
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile-phone",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3687",
    "data-name": "Group 3687",
    transform: "translate(8047.407 -11456.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3012",
    "data-name": "Group 3012",
    transform: "matrix(-0.087, 0.996, -0.996, -0.087, -14541.056, 16637.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2632",
    "data-name": "Group 2632",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2606",
    "data-name": "Group 2606",
    transform: "translate(0 7.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2598",
    "data-name": "Group 2598",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    className: "cls-2",
    d: "M12.228,36.72a1.619,1.619,0,0,0,2.118.837l16.918-7.636a1.617,1.617,0,0,0,.784-2.144l-5.674-12.6L19.994.975A1.619,1.619,0,0,0,17.876.138L.931,7.773A1.617,1.617,0,0,0,.147,9.918L6.527,24.09h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1489",
    "data-name": "Rectangle 1489",
    className: "cls-3",
    width: 32.66,
    height: 2.746,
    transform: "matrix(-0.411, -0.912, 0.912, -0.411, 15.869, 36.883)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1490",
    "data-name": "Rectangle 1490",
    className: "cls-2",
    width: 8.708,
    height: 1.02,
    transform: "matrix(-0.411, -0.912, 0.912, -0.411, 19.434, 31.716)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1491",
    "data-name": "Rectangle 1491",
    className: "cls-2",
    width: 26.437,
    height: 1.02,
    transform: "matrix(-0.411, -0.912, 0.912, -0.411, 21.373, 30.843)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1492",
    "data-name": "Rectangle 1492",
    className: "cls-2",
    width: 26.437,
    height: 1.02,
    transform: "matrix(-0.411, -0.912, 0.912, -0.411, 23.313, 29.967)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605",
    transform: "translate(25.696 24.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2599",
    "data-name": "Group 2599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    className: "cls-4",
    d: "M1.855.051a.574.574,0,0,1,.758.288l.994,2.2a.574.574,0,0,1-.288.758L1.8,3.973a.574.574,0,0,1-.758-.288l-.994-2.2A.574.574,0,0,1,.338.731Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2604",
    "data-name": "Group 2604",
    className: "cls-5",
    transform: "translate(0.299 0.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    className: "cls-6",
    d: "M1.438,0,2.3,1.909.863,2.563,0,.654Zm.575,1.8L1.334.314.288.784l.68,1.49Z",
    transform: "translate(0.379 0.68)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2600",
    "data-name": "Group 2600",
    transform: "translate(0 1.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1493",
    "data-name": "Rectangle 1493",
    className: "cls-6",
    width: 0.732,
    height: 0.235,
    transform: "matrix(0.912, -0.411, 0.411, 0.912, 0.422, 1.274)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1494",
    "data-name": "Rectangle 1494",
    className: "cls-6",
    width: 0.732,
    height: 0.235,
    transform: "matrix(0.912, -0.411, 0.411, 0.912, 0, 0.301)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2601",
    "data-name": "Group 2601",
    transform: "translate(1.88 0.831)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    className: "cls-6",
    width: 0.732,
    height: 0.235,
    transform: "matrix(0.912, -0.411, 0.411, 0.912, 0.446, 1.263)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496",
    "data-name": "Rectangle 1496",
    className: "cls-6",
    width: 0.732,
    height: 0.235,
    transform: "matrix(0.912, -0.411, 0.411, 0.912, 0, 0.301)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2602",
    "data-name": "Group 2602",
    transform: "translate(0.039 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    className: "cls-6",
    d: "M.449,0A.323.323,0,0,1,.292.445.116.116,0,0,0,.24.6L.371.915.162.994.031.68A.336.336,0,0,1,.188.235.1.1,0,0,0,.24.078Z",
    transform: "translate(1.041 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    className: "cls-6",
    d: "M.811.235.941.549.732.628.6.314C.575.235.523.235.445.261A.347.347,0,0,1,0,.078L.209,0A.116.116,0,0,0,.366.052.334.334,0,0,1,.811.235Z",
    transform: "translate(0 0.575)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2603",
    "data-name": "Group 2603",
    transform: "translate(1.468 2.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    className: "cls-6",
    d: "M.941.549.732.628A.116.116,0,0,0,.575.575.326.326,0,0,1,.131.392L0,.078.209,0,.34.314C.366.392.418.392.5.366A.338.338,0,0,1,.941.549Z",
    transform: "translate(0.584 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    className: "cls-6",
    d: "M.323,0,.454.314A.336.336,0,0,1,.3.758.1.1,0,0,0,.244.915L.035.994A.323.323,0,0,1,.192.549.116.116,0,0,0,.244.392L.114.078Z",
    transform: "translate(0 0.209)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615",
    transform: "translate(13.117 4.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2607",
    "data-name": "Group 2607",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    className: "cls-7",
    d: "M0,31.039A1.607,1.607,0,0,0,1.6,32.66l18.566.026a1.607,1.607,0,0,0,1.6-1.621l.026-13.859.026-15.559a1.607,1.607,0,0,0-1.6-1.621L1.647,0a1.607,1.607,0,0,0-1.6,1.621L.026,17.18h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1497",
    "data-name": "Rectangle 1497",
    className: "cls-3",
    width: 32.66,
    height: 2.746,
    transform: "translate(3.26 32.669) rotate(-89.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1498",
    "data-name": "Rectangle 1498",
    className: "cls-7",
    width: 8.708,
    height: 1.02,
    transform: "translate(8.627 29.421) rotate(-89.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1499",
    "data-name": "Rectangle 1499",
    className: "cls-7",
    width: 26.437,
    height: 1.02,
    transform: "translate(10.74 29.415) rotate(-89.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1500",
    "data-name": "Rectangle 1500",
    className: "cls-7",
    width: 26.437,
    height: 1.02,
    transform: "translate(12.859 29.42) rotate(-89.938)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(16.892 25.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2608",
    "data-name": "Group 2608",
    transform: "translate(0 0.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    className: "cls-4",
    d: "M2.249,0a.58.58,0,0,1,.575.575V2.981a.58.58,0,0,1-.575.575H.575A.58.58,0,0,1,0,2.981V.575A.58.58,0,0,1,.575,0Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613",
    className: "cls-5",
    transform: "translate(0.003 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    className: "cls-6",
    d: "M1.6,0V2.092H0V0ZM1.386,1.883V.235H.235V1.883Z",
    transform: "translate(0.598 0.758)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2609",
    "data-name": "Group 2609",
    transform: "translate(0 1.186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1501",
    "data-name": "Rectangle 1501",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0.016 1.289) rotate(-89.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1502",
    "data-name": "Rectangle 1502",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0 0.235) rotate(-89.938)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2610",
    "data-name": "Group 2610",
    transform: "translate(2.076 1.201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1503",
    "data-name": "Rectangle 1503",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0.016 1.289) rotate(-89.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1504",
    "data-name": "Rectangle 1504",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0 0.235) rotate(-89.938)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2611",
    "data-name": "Group 2611",
    transform: "translate(0.598 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    className: "cls-6",
    d: "M.654,0a.345.345,0,0,1-.34.34c-.078,0-.1.052-.1.131v.34H0V.471A.33.33,0,0,1,.34.131a.11.11,0,0,0,.1-.1Z",
    transform: "translate(0.968 0.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    className: "cls-6",
    d: "M.654.471v.34H.445V.471A.12.12,0,0,0,.34.34.345.345,0,0,1,0,0H.209a.1.1,0,0,0,.1.1A.368.368,0,0,1,.654.471Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2612",
    "data-name": "Group 2612",
    transform: "translate(0.598 2.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    className: "cls-6",
    d: "M.654.784H.445a.1.1,0,0,0-.1-.1A.346.346,0,0,1,0,.34V0H.209V.34a.12.12,0,0,0,.1.131A.3.3,0,0,1,.654.784Z",
    transform: "translate(0.968 0.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    className: "cls-6",
    d: "M.654.026v.34a.33.33,0,0,1-.34.34.11.11,0,0,0-.1.1H0A.345.345,0,0,1,.34.471c.078,0,.1-.052.1-.131V0Z",
    transform: "translate(0 0)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    className: "cls-8",
    d: "M.127,28.05a1.615,1.615,0,0,0,.837,2.118l17.075,7.269a1.645,1.645,0,0,0,2.118-.863L25.6,23.84l6.093-14.3a1.615,1.615,0,0,0-.837-2.118L13.776.123a1.645,1.645,0,0,0-2.118.863l-6.093,14.3h0Z",
    transform: "translate(17.226 0.112)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    className: "cls-3",
    width: 32.66,
    height: 2.746,
    transform: "translate(19.711 30.941) rotate(-66.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1506",
    "data-name": "Rectangle 1506",
    className: "cls-8",
    width: 8.708,
    height: 1.02,
    transform: "translate(25.934 30.049) rotate(-66.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1507",
    "data-name": "Rectangle 1507",
    className: "cls-8",
    width: 26.437,
    height: 1.02,
    transform: "translate(27.886 30.87) rotate(-66.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1508",
    "data-name": "Rectangle 1508",
    className: "cls-8",
    width: 26.437,
    height: 1.02,
    transform: "translate(29.835 31.719) rotate(-66.914)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2622",
    "data-name": "Group 2622",
    transform: "translate(33.724 30.181)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    className: "cls-4",
    d: "M3.293.7a.574.574,0,0,1,.288.758L2.64,3.681A.586.586,0,0,1,1.881,4L.338,3.341a.574.574,0,0,1-.288-.758L.992.36A.586.586,0,0,1,1.751.047Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2621",
    "data-name": "Group 2621",
    className: "cls-5",
    transform: "translate(0.268 0.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    className: "cls-6",
    d: "M2.275.628,1.464,2.563,0,1.935.811,0ZM1.334,2.275,1.987.758.941.314.288,1.83Z",
    transform: "translate(0.411 0.68)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    transform: "translate(0 0.859)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1509",
    "data-name": "Rectangle 1509",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0 1.19) rotate(-66.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1510",
    "data-name": "Rectangle 1510",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0.418 0.216) rotate(-66.914)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(1.907 1.675)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1511",
    "data-name": "Rectangle 1511",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0 1.19) rotate(-66.914)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1512",
    "data-name": "Rectangle 1512",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0.418 0.216) rotate(-66.914)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2619",
    "data-name": "Group 2619",
    transform: "translate(1.464 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    className: "cls-6",
    d: "M.941.078A.338.338,0,0,1,.5.261.116.116,0,0,0,.34.314L.209.628,0,.549.131.235A.326.326,0,0,1,.575.052.148.148,0,0,0,.732,0Z",
    transform: "translate(0.595 0.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    className: "cls-6",
    d: "M.464.68.333.994.124.915.255.6A.116.116,0,0,0,.2.445.358.358,0,0,1,.019,0L.228.078C.2.131.2.183.281.235A.334.334,0,0,1,.464.68Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2620",
    "data-name": "Group 2620",
    transform: "translate(0.071 2.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    className: "cls-6",
    d: "M.475.994.266.915C.292.863.292.811.213.758A.326.326,0,0,1,.03.314L.161,0,.37.078.239.392A.116.116,0,0,0,.292.549.315.315,0,0,1,.475.994Z",
    transform: "translate(1.042 0.209)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    className: "cls-6",
    d: "M.941.078.811.392A.326.326,0,0,1,.366.575.148.148,0,0,0,.209.628L0,.549A.338.338,0,0,1,.445.366.116.116,0,0,0,.6.314L.732,0Z",
    transform: "translate(0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2631",
    "data-name": "Group 2631",
    transform: "translate(22.83 7.085) rotate(-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2623",
    "data-name": "Group 2623",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    className: "cls-9",
    d: "M.484,21.246a1.61,1.61,0,0,0-.026,2.275l13.1,13.153a1.61,1.61,0,0,0,2.275-.026l9.806-9.78L36.648,15.886a1.61,1.61,0,0,0,.026-2.275L23.574.458A1.61,1.61,0,0,0,21.3.484L10.29,11.467h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1513",
    "data-name": "Rectangle 1513",
    className: "cls-3",
    width: 32.66,
    height: 2.746,
    transform: "translate(1.613 24.725) rotate(-44.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1514",
    "data-name": "Rectangle 1514",
    className: "cls-10",
    width: 8.708,
    height: 1.02,
    transform: "translate(7.72 26.222) rotate(-44.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1515",
    "data-name": "Rectangle 1515",
    className: "cls-10",
    width: 26.437,
    height: 1.02,
    transform: "translate(9.211 27.727) rotate(-44.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1516",
    "data-name": "Rectangle 1516",
    className: "cls-10",
    width: 26.437,
    height: 1.02,
    transform: "translate(10.714 29.245) rotate(-44.935)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2630",
    "data-name": "Group 2630",
    transform: "translate(13.82 29.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2624",
    "data-name": "Group 2624",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    className: "cls-4",
    d: "M3.844,1.353a.6.6,0,0,1,0,.811l-1.7,1.7a.553.553,0,0,1-.811,0L.157,2.687a.6.6,0,0,1,0-.811l1.7-1.7a.553.553,0,0,1,.811,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629",
    className: "cls-5",
    transform: "translate(0.157 0.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    className: "cls-6",
    d: "M2.615,1.124,1.124,2.615,0,1.49,1.49,0ZM1.124,2.3,2.3,1.151,1.49.34.314,1.49Z",
    transform: "translate(0.523 0.523)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625",
    transform: "translate(0.373 0.418)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1517",
    "data-name": "Rectangle 1517",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0 0.892) rotate(-44.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1518",
    "data-name": "Rectangle 1518",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0.746 0.166) rotate(-44.935)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626",
    transform: "translate(1.834 1.887)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1519",
    "data-name": "Rectangle 1519",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0 0.892) rotate(-44.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1520",
    "data-name": "Rectangle 1520",
    className: "cls-6",
    width: 0.235,
    height: 0.732,
    transform: "translate(0.746 0.166) rotate(-44.935)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2627",
    "data-name": "Group 2627",
    transform: "translate(2.275 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    className: "cls-6",
    d: "M1.02.255a.331.331,0,0,1-.471,0,.1.1,0,0,0-.157,0L.157.49,0,.333.235.1A.331.331,0,0,1,.706.1.118.118,0,0,0,.863.1Z",
    transform: "translate(0.392 0.896)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    className: "cls-6",
    d: "M.392.784.157,1.02,0,.863.235.628a.1.1,0,0,0,0-.157A.33.33,0,0,1,.235,0L.392.157a.118.118,0,0,0,0,.157A.294.294,0,0,1,.392.784Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2628",
    "data-name": "Group 2628",
    transform: "translate(0 2.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    className: "cls-6",
    d: "M.255,1.02.1.863A.118.118,0,0,0,.1.706.331.331,0,0,1,.1.235L.333,0,.49.157.255.392a.1.1,0,0,0,0,.157A.33.33,0,0,1,.255,1.02Z",
    transform: "translate(0.896 0.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    className: "cls-6",
    d: "M1.02.157.784.392a.332.332,0,0,1-.471,0,.118.118,0,0,0-.157,0L0,.235a.331.331,0,0,1,.471,0,.1.1,0,0,0,.157,0L.863,0Z",
    transform: "translate(0 0)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3013",
    "data-name": "Group 3013",
    transform: "translate(-14570.799 16635.156) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    className: "cls-11",
    d: "M62.758,2.615V33.994a2.623,2.623,0,0,1-2.615,2.615H2.615A2.623,2.623,0,0,1,0,33.994V2.615A2.623,2.623,0,0,1,2.615,0H60.143A2.606,2.606,0,0,1,62.758,2.615Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    className: "cls-11",
    d: "M62.758,0V15.689A2.623,2.623,0,0,1,60.143,18.3H2.615A2.623,2.623,0,0,1,0,15.689V0Z",
    transform: "translate(0 18.304)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1521",
    "data-name": "Rectangle 1521",
    className: "cls-7",
    width: 31.379,
    height: 49.736,
    transform: "translate(5.236 33.983) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    className: "cls-12",
    d: "M1.307.261V7.583a.247.247,0,0,1-.261.262H.261A.262.262,0,0,1,0,7.583V.261A.281.281,0,0,1,.261,0h.784A.247.247,0,0,1,1.307.261Z",
    transform: "translate(1.961 14.382)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    className: "cls-12",
    cx: 2.615,
    cy: 2.615,
    r: 2.615,
    transform: "translate(56.221 15.689)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavyFederalCreditUnionLandingImage);
export default __webpack_public_path__ + "static/media/NavyFederalCreditUnionLandingImage.58c86d6bedcdb9b7c6b4f36e53138453.svg";
export { ForwardRef as ReactComponent };